import React from 'react';
import { FormattedMessage } from 'react-intl';

import { TERMS_AND_CONDITIONS_LINK, TERMS_AND_CONDITIONS_LINK_SUMMER_CONTEST } from 'modules/campaigns/constants';

import { useGetCampaignAuthor } from './hooks/useGetCampaignAuthor';
import { AgreementsDetails } from '../../../components/agreements-section/AgreementsDetails';
import { useAdCampaignTranslationKeys } from '../../hooks/useAdCampaignTranslationKeys';

type Props = {
  campaignAuthor: string | undefined;
};

export const NewCampaignAgreementDetails: React.FC<Props> = ({ campaignAuthor }) => {
  const translationKeysPerCountry = useAdCampaignTranslationKeys();
  const { author, isFetching: isLoadingAuthor } = useGetCampaignAuthor({
    authorName: campaignAuthor || '',
    isEnabled: !!campaignAuthor,
  });

  return (
    <AgreementsDetails
      agreements={[
        <FormattedMessage
          id={translationKeysPerCountry.agreementStatement}
          values={{
            link: (
              <a href={TERMS_AND_CONDITIONS_LINK} target="_blank" rel="noreferrer">
                <FormattedMessage id="campaigns.agreements.terms-and-conditions-link" />
              </a>
            ),
            summerContestLink: (
              <a href={TERMS_AND_CONDITIONS_LINK_SUMMER_CONTEST} target="_blank" rel="noreferrer">
                <FormattedMessage id="campaigns.agreements.terms-and-conditions-link-summer-contest" />
              </a>
            ),
          }}
        />,
      ]}
      isLoading={isLoadingAuthor}
      author={author}
      isCreatedByWolt={author?.email.endsWith('@wolt.com')} // TODO: replade with campaign.created_by_wolt when it will be available
    />
  );
};
